/* CorkProTech · ficha de los packs (sections/main-pack.liquid, datos en snippets/pack-data.liquid).
   Contrato con el ERP (06/10/2026): «Añadir» mete UNA línea con la variante del pack y, como
   propiedades, las visibles «Funda 1», «Funda 2», «Cordones» o «Cordón» y las ocultas _funda_1,
   _funda_2, _cordones y, con «A tu gusto», _cordon_1, _cordon_2 y _cordon_3 (ids de variante, en
   número). Los llaveros no llevan propiedad. Sin todo elegido, el botón no se activa: el ERP manda a
   supervisión el pedido al que le falta algo.
   Dream Team: cinco fundas, cada una con su línea (Slim o Extreme) y siempre en Classic, porque llevan
   el logo del cliente; cinco cordones sueltos y cinco llaveros. Ocultas _funda_1 … _funda_5 y
   _cordon_1 … _cordon_5; visibles «Funda 1: iPhone 17 Pro · Slim» … «Funda 5», «Cordones: Rojo,
   Negro, …» y «Logo: se sube después de pagar». */
(() => {
  const money = (cents) => window.CorkMoney(cents);
  const displayValue = (value) => String(value).replace(/Iphone/g, 'iPhone');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* Valor de «Logo» en la línea del Dream Team: es parte del contrato con el ERP, no se traduce. */
  const LOGO_PENDING = 'se sube después de pagar';
  /* La foto de los cordones «A tu gusto» se reconoce por su nombre (fotos-packs/LEEME-donde-va.txt):
     pack-funda-cordones-a-tu-gusto.jpg. */
  const CUSTOM_PHOTO = /-a-tu-gusto[^/]*$/;

  /* «slim,extreme|pack|0|0» (snippets/pack-spec.liquid). */
  const parseSpec = (spec) => {
    const [slots, cords, keyrings, logo] = spec.split('|');
    return { slots: slots ? slots.split(',') : [], cords, keyrings: Number(keyrings) || 0, logo: logo === '1' };
  };

  /* Descuento automático por unidades (no se combina con el de la 2ª funda: gana el mayor): 3 o 4
     artículos, −4 €; de 5 a 10, 2 € por artículo. La tienda no deja más de 10 artículos por pedido: con
     más (las 15 piezas del Dream Team), irían en dos pedidos, cada uno con su descuento, y sigue siendo 2 €
     por artículo. Los mismos tramos en pack-card. */
  const volume = (items) => (items >= 5 ? items * 200 : items >= 3 ? 400 : 0);

  class Pack {
    constructor(root) {
      this.root = root;
      this.data = JSON.parse(root.querySelector('[data-pack-json]').textContent);
      this.t = this.data.t;
      this.variant = this.data.pack.find((v) => v.id === this.data.current) || this.data.pack[0];
      this.slots = Array.from({ length: 5 }, () => ({ model: '', design: 'Classic', line: 'slim' }));
      this.custom = [null, null, null];
      /* Cordones del Dream Team: un color por funda, la ficha que se está eligiendo y «Todos del mismo color». */
      this.set = Array(5).fill(null);
      this.setActive = 0;
      this.same = false;
      /* Fundas que se eligen de una en una (línea a elegir): la que está abierta. */
      this.open = 0;
      const checked = (selector) => root.querySelector(`${selector}:checked`);
      this.cordPackId = Number(checked('[data-pack-cordpack]')?.value) || 0;
      this.cordId = Number(checked('[data-pack-cord-input]')?.value) || 0;
      this.button = root.querySelector('[data-pack-add]');
      const delivery = root.querySelector('[data-delivery]');
      this.delivery = delivery && window.CorkDelivery ? new window.CorkDelivery(delivery, this) : null;
      /* Galería de la ficha (Gallery de product.js) con todas las fotos del pack, en su orden: sin variantes,
         no las agrupa por modelo como en las fundas. Abre en la foto de la variante. */
      this.gallery = window.CorkGallery ? new window.CorkGallery(root.closest('.pdp'), { ...this.data.gallery, extras: [], variants: [] }) : null;
      this.gallery?.show(null, this.variant.f);
      this.customPhoto = this.data.gallery.media.find((m) => CUSTOM_PHOTO.test(m.s.split('?')[0]))?.id;
      this.setupPickers();
      /* Con las flechas, un grupo de radios cambia de valor a cada pulsación: recorrer los móviles o los
         colores elige, pero no pasa a la siguiente funda ni al siguiente cordón (eso, con un toque, un clic o
         la barra espaciadora). El 'change' llega en la misma tarea que la tecla. */
      root.addEventListener('keydown', (event) => {
        if (!event.key.startsWith('Arrow')) return;
        this.arrowing = true;
        setTimeout(() => { this.arrowing = false; });
      }, true);
      root.addEventListener('change', (event) => this.change(event.target));
      root.addEventListener('click', (event) => this.click(event.target));
      this.button.addEventListener('click', () => this.add());
      this.setupSticky();
      this.render();
    }

    /* Isla fija de compra, como la de la ficha de producto (StickyBuy de product.js): aparece cuando el botón
       principal sale de pantalla (en móvil, además, tras pasar el precio). Si falta algo, su botón dice qué y
       lleva a lo primero que falta; con todo elegido, añade el pack. */
    setupSticky() {
      const bar = this.root.querySelector('[data-pack-sticky]');
      if (!bar) return;
      this.sticky = { bar, price: bar.querySelector('[data-pack-sticky-price]'), button: bar.querySelector('[data-pack-sticky-add]') };
      document.body.append(bar);
      this.sticky.button.addEventListener('click', () => (this.firstMissing() ? this.goToMissing() : this.add()));
      const wide = window.matchMedia('(min-width: 990px)');
      const priceBox = this.root.querySelector('[data-pack-price]');
      const update = () => {
        const rect = this.button.getBoundingClientRect();
        const inView = rect.bottom > 0 && rect.top < window.innerHeight;
        const past = wide.matches ? rect.top < 0 : priceBox.getBoundingClientRect().bottom < 0;
        const visible = !inView && past;
        bar.classList.toggle('is-visible', visible);
        bar.inert = !visible;
      };
      let frame;
      window.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    /* Lo primero que falta por elegir: el móvil de una funda o los colores de los cordones. */
    firstMissing() {
      const { slots, cords } = this.spec;
      const i = slots.findIndex((_, k) => !this.slots[k].model);
      if (i > -1) return { kind: 'model', i };
      const colors = (cords === 'pack' && this.cordPack?.custom && this.custom.some((id) => !id))
        || (cords === 'set' && this.setIds().some((id) => !id));
      return colors ? { kind: 'cords' } : null;
    }

    /* Lleva a lo que falta (abre la funda si es del Dream Team) y deja el foco ahí. */
    goToMissing() {
      const miss = this.firstMissing();
      const behavior = reduceMotion.matches ? 'auto' : 'smooth';
      let target;
      if (miss.kind === 'model') {
        target = this.root.querySelector(`[data-pack-slot="${miss.i + 1}"]`);
        if (this.spec.slots[miss.i] === 'any' && this.open !== miss.i) {
          this.open = miss.i;
          this.render();
        }
      } else {
        target = this.root.querySelector('[data-pack-set]:not([hidden]), [data-pack-cords]:not([hidden])');
      }
      if (!target) return;
      target.scrollIntoView({ behavior, block: 'start' });
      target.querySelector('[data-pack-toggle], input:not([disabled]):not([type="hidden"]), button:not([disabled])')?.focus({ preventScroll: true });
    }

    renderSticky() {
      if (!this.sticky) return;
      const { price, button } = this.sticky;
      price.textContent = this.root.querySelector('[data-pack-price]').textContent;
      if (this.button.hasAttribute('aria-busy')) {
        button.disabled = true;
        button.textContent = this.t.adding;
        return;
      }
      const miss = this.firstMissing();
      /* Agotado (el pack o la funda elegida): como el botón principal, no se puede añadir. */
      const blocked = !this.variant.a || (!miss && this.missing().length > 0);
      button.disabled = blocked;
      if (blocked) button.textContent = this.t.soldOut;
      else if (miss) button.textContent = miss.kind === 'model' ? button.dataset.labelModel : button.dataset.labelCords;
      else button.textContent = button.dataset.labelAdd;
    }

    get spec() {
      return parseSpec(this.variant.spec);
    }

    /* Línea de la funda de una posición: la del pack o, en el Dream Team, la elegida en esa funda. */
    kindOf(i) {
      const kind = this.spec.slots[i];
      return kind === 'any' ? this.slots[i].line : kind;
    }

    /* «Elige tu móvil» de la ficha (ModelPicker de product.js), uno por funda y tipo. Solo necesita
       un objeto con root, el modelo actual y su posición; el cambio llega como 'change' de su radio. */
    setupPickers() {
      this.pickers = [];
      this.root.querySelectorAll('[data-pack-slot]').forEach((slotEl) => {
        slotEl.querySelectorAll('[data-pack-picker]').forEach((pickerEl) => {
          const adapter = { root: pickerEl, variant: { o: ['Iphone'] }, modelIndex: 0 };
          if (window.CorkPicker) new window.CorkPicker(adapter);
          adapter.variant.o[0] = '';
          this.pickers.push({ slot: Number(slotEl.dataset.packSlot) - 1, kind: pickerEl.dataset.packPicker, el: pickerEl, adapter });
        });
      });
    }

    slotOf(target) {
      return Number(target.closest('[data-pack-slot]').dataset.packSlot) - 1;
    }

    change(target) {
      if (target.matches('[data-pack-option]')) {
        const chosen = [...this.root.querySelectorAll('[data-pack-option]:checked')].reduce((acc, input) => {
          acc[Number(input.dataset.packOption)] = input.value;
          return acc;
        }, {});
        this.variant = this.data.pack.find((v) => Object.entries(chosen).every(([i, value]) => v.o[Number(i)] === value)) || this.variant;
        this.keepModels();
        this.gallery?.goTo(this.variant.f);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.variant.id);
        window.history.replaceState(window.history.state, '', url);
      } else if (target.matches('[data-pack-picker] [data-option]')) {
        const slot = this.slotOf(target);
        this.slots[slot].model = target.value;
        if (this.spec.slots[slot] === 'any' && !this.arrowing) this.advance(slot);
      } else if (target.matches('[data-pack-line]')) {
        this.slots[this.slotOf(target)].line = target.value;
        this.keepModels();
      } else if (target.matches('[data-pack-design]')) {
        this.slots[this.slotOf(target)].design = target.value;
      } else if (target.matches('[data-pack-cordpack]')) {
        this.cordPackId = Number(target.value);
        /* «A tu gusto» enseña su foto (si el pack la tiene) y los demás packs de cordones, la de la variante. */
        this.gallery?.goTo(this.cordPack?.custom ? this.customPhoto : this.variant.f);
      } else if (target.matches('[data-pack-custom-input]')) {
        const group = target.closest('[data-pack-custom-group]');
        this.custom[Number(group.dataset.packCustomGroup) - 1] = Number(target.value);
        group.querySelector('[data-cord-selected]').textContent = target.dataset.color;
      } else if (target.matches('[data-pack-cord-input]')) {
        this.cordId = Number(target.value);
        target.closest('[data-pack-cord]').querySelector('[data-cord-selected]').textContent = target.dataset.color;
      } else if (target.matches('[data-pack-set-input]')) {
        this.chooseSetColor(Number(target.value));
      } else if (target.matches('[data-pack-set-same]')) {
        this.same = target.checked;
        const color = this.set[this.setActive] || this.set.find(Boolean);
        if (this.same && color) this.set.fill(color);
      } else {
        return;
      }
      this.render();
    }

    click(target) {
      const toggle = target.closest('[data-pack-toggle]');
      const same = target.closest('[data-pack-same]');
      const token = target.closest('[data-set-token]');
      if (toggle) {
        const i = this.slotOf(toggle);
        this.open = this.open === i ? -1 : i;
      } else if (same) {
        const i = this.slotOf(same);
        const { model, line } = this.slots[0];
        Object.assign(this.slots[i], { model, line });
        if (this.open === i) this.advance(i);
        else this.focusSlot = i;
      } else if (token) {
        this.setActive = Number(token.dataset.setToken) - 1;
      } else {
        return;
      }
      this.render();
    }

    /* Tras elegir el móvil de una funda, se abre la siguiente que falta (y se cierra si no falta ninguna). */
    advance(from) {
      const n = this.spec.slots.length;
      const next = [...Array(n).keys()].map((k) => (from + 1 + k) % n).find((i) => !this.slots[i].model);
      this.open = next === undefined ? -1 : next;
      this.scrollToOpen = next !== undefined;
      this.focusSlot = next === undefined ? from : next;
    }

    /* Cordones del Dream Team: el color va a la ficha elegida (o a las cinco con «Todos del mismo color»)
       y se pasa a la siguiente que falta, salvo si se recorren los colores con las flechas. */
    chooseSetColor(id) {
      if (this.same) {
        this.set.fill(id);
        return;
      }
      this.set[this.setActive] = id;
      if (this.arrowing) return;
      const n = this.spec.slots.length;
      const next = [...Array(n).keys()].map((k) => (this.setActive + 1 + k) % n).find((i) => !this.set[i]);
      if (next !== undefined) this.setActive = next;
    }

    /* Al cambiar de Slim a Extreme (o al revés), el móvil elegido se queda si esa funda lo tiene. */
    keepModels() {
      this.spec.slots.forEach((_, i) => {
        const c = this.data.cases[this.kindOf(i)];
        const slot = this.slots[i];
        if (slot.model && !c.v.some((v) => v.o[c.m] === slot.model)) slot.model = '';
      });
    }

    caseVariant(i) {
      const c = this.data.cases[this.kindOf(i)];
      const slot = this.slots[i];
      if (!slot.model) return null;
      return c.v.find((v) => v.o[c.m] === slot.model && (c.d < 0 || v.o[c.d] === slot.design)) || null;
    }

    /* Diseños que existen para el modelo elegido (hay modelos solo en Classic). */
    designsFor(model) {
      const c = this.data.cases.slim;
      return new Set(c.v.filter((v) => !model || v.o[c.m] === model).map((v) => v.o[c.d]));
    }

    /* Alguna Slim con un diseño grabado (una variante que no es Classic). */
    hasDesign() {
      return this.spec.slots.some((_, i) => this.data.cases[this.kindOf(i)].d > -1 && this.slots[i].design.toLowerCase() !== 'classic');
    }

    /* Para la entrega estimada (Delivery de product.js): un diseño o un logo se graban bajo pedido. */
    isEngraved() {
      return this.spec.logo || this.hasDesign();
    }

    /* Entrega del Dream Team: empieza cuando llega el logo (texto de la sección). */
    deliveryNote() {
      return this.spec.logo && this.t.logoDeliveryMain ? { main: this.t.logoDeliveryMain, sub: this.t.logoDeliverySub } : null;
    }

    get cordPack() {
      return this.data.cordPacks.find((c) => c.id === this.cordPackId) || null;
    }

    get cord() {
      return this.data.cords.find((c) => c.id === this.cordId) || null;
    }

    /* Para el pedido: el nombre en español (pack-data, «es»), que es el que leen el ERP y quien empaqueta. */
    colorName(id) {
      const cord = this.data.cords.find((c) => c.id === id);
      return cord?.es || cord?.t || '';
    }

    setIds() {
      return this.set.slice(0, this.spec.slots.length);
    }

    slotTitle(i) {
      const { slots } = this.spec;
      const label = slots.length < 2 ? this.t.single : this.t.titles[i];
      return slots[i] === 'any' ? label : `${label} · Cork ${this.data.cases[slots[i]].name}`;
    }

    /* «iPhone 17 Pro · Slim · Ibiza»: con el logo, sin diseño. */
    caseText(i, empty) {
      const kind = this.kindOf(i);
      const slot = this.slots[i];
      const parts = [slot.model ? displayValue(slot.model) : empty, this.data.cases[kind].name];
      if (this.data.cases[kind].d > -1 && !this.spec.logo) parts.push(slot.design);
      return parts.join(' · ');
    }

    missing() {
      const { slots, cords } = this.spec;
      const out = [];
      if (slots.includes('any')) {
        const left = slots.filter((_, i) => !this.slots[i].model).length;
        if (left) out.push(left === 1 ? this.t.missOne : this.t.missMany.replace('[n]', left));
      }
      slots.forEach((kind, i) => {
        if (!this.slots[i].model) {
          if (kind !== 'any') out.push(slots.length < 2 ? this.t.missSingle : i === 0 ? this.t.missFirst : this.t.missSecond);
        } else if (!this.caseVariant(i)?.a) {
          out.push(`${this.slotTitle(i)}: ${this.t.soldOut}`);
        }
      });
      if (cords === 'pack' && this.cordPack?.custom && this.custom.some((id) => !id)) out.push(this.t.missColors);
      if (cords === 'set' && this.setIds().some((id) => !id)) out.push(this.same ? this.t.missSame : this.t.missSet);
      return out;
    }

    /* Lo que cuesta suelta la funda de una posición: la elegida o, sin móvil, la más barata de su diseño. */
    casePrice(i) {
      const c = this.data.cases[this.kindOf(i)];
      const { model, design } = this.slots[i];
      return Math.min(...c.v.filter((v) => (!model || v.o[c.m] === model) && (c.d < 0 || v.o[c.d] === design)).map((v) => v.p));
    }

    /* Precio por separado: lo que se pagaría hoy por las piezas sueltas (Fran, 06/10/2026), con el mejor
       descuento automático de la tienda, que no se combinan: 2ª funda del mismo tipo −5 € (−7,99 € entre
       dos Slim si alguna lleva diseño) o por unidades (volume). La tarjeta de la colección (pack-card)
       hace la misma cuenta y packs-contrato.mjs la compara con un carrito de Shopify. */
    separate() {
      const { slots, cords, keyrings } = this.spec;
      const cheapestCord = Math.min(...this.data.cords.map((c) => c.p));
      let extras = [];
      if (cords === 'pack' && this.cordPack) extras = [this.cordPack.p];
      if (cords === 'single' && this.cord) extras = [this.cord.p];
      if (cords === 'set') extras = this.setIds().map((id) => this.data.cords.find((c) => c.id === id)?.p ?? cheapestCord);
      const items = slots.length + extras.length + keyrings;
      const total = slots.reduce((sum, _, i) => sum + this.casePrice(i), 0) + extras.reduce((sum, p) => sum + p, 0) + keyrings * this.data.keyring.p;
      const kinds = slots.map((_, i) => this.kindOf(i));
      const pairOf = (kind) => kinds.filter((k) => k === kind).length >= 2;
      const second = pairOf('slim') ? (this.hasDesign() ? 799 : 500) : pairOf('extreme') ? 500 : 0;
      return total - Math.max(second, volume(items));
    }

    properties() {
      const { slots, cords, logo } = this.spec;
      const visible = {};
      const hidden = {};
      slots.forEach((_, i) => {
        visible[`Funda ${i + 1}`] = this.caseText(i, '');
        hidden[`_funda_${i + 1}`] = String(this.caseVariant(i).id);
      });
      if (cords === 'pack') {
        const pack = this.cordPack;
        visible.Cordones = pack.custom ? this.custom.map((id) => this.colorName(id)).join(' · ') : pack.t;
        hidden._cordones = String(pack.id);
        if (pack.custom) this.custom.forEach((id, n) => { hidden[`_cordon_${n + 1}`] = String(id); });
      } else if (cords === 'single') {
        visible['Cordón'] = this.cord.es || this.cord.t;
        hidden._cordones = String(this.cord.id);
      } else if (cords === 'set') {
        visible.Cordones = this.setIds().map((id) => this.colorName(id)).join(', ');
        this.setIds().forEach((id, n) => { hidden[`_cordon_${n + 1}`] = String(id); });
      }
      if (logo) visible.Logo = LOGO_PENDING;
      return { ...visible, ...hidden };
    }

    async add() {
      if (this.missing().length || !this.variant.a) return;
      const error = this.root.querySelector('[data-pack-error]');
      const label = this.root.querySelector('[data-pack-add-label]');
      const text = label.textContent;
      error.hidden = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      label.textContent = this.t.adding;
      this.renderSticky();
      try {
        await window.CorkCart.add([{ id: this.variant.id, quantity: 1, properties: this.properties() }]);
      } catch (err) {
        error.textContent = err.message || this.t.error;
        error.hidden = false;
      } finally {
        label.textContent = text;
        this.button.removeAttribute('aria-busy');
        this.render();
      }
    }

    render() {
      const spec = this.spec;
      this.renderSlots(spec);
      this.renderCords(spec);
      this.renderPrice();
      this.renderSummary(spec);
      const missing = this.missing();
      this.root.querySelector('[data-pack-missing]').textContent = this.variant.a ? missing.join(' ') : this.t.soldOut;
      if (!this.button.hasAttribute('aria-busy')) this.button.disabled = missing.length > 0 || !this.variant.a;
      this.renderSticky();
      this.delivery?.render();
      document.querySelector('[data-ship-24h]')?.toggleAttribute('hidden', this.isEngraved());
    }

    renderSlots(spec) {
      this.root.querySelectorAll('[data-pack-slot]').forEach((slotEl) => {
        const i = Number(slotEl.dataset.packSlot) - 1;
        slotEl.hidden = !spec.slots[i];
        if (!spec.slots[i]) return;
        const kind = this.kindOf(i);
        const slot = this.slots[i];
        slotEl.querySelector('[data-slot-title]').textContent = this.slotTitle(i);
        if (spec.slots[i] === 'any') this.renderStep(slotEl, i);
        this.pickers.filter((p) => p.slot === i).forEach((p) => {
          p.el.hidden = p.kind !== kind;
          if (p.kind !== kind) return;
          p.el.querySelectorAll('[data-option]').forEach((input) => { input.checked = input.value === slot.model; });
          p.adapter.variant.o[0] = slot.model;
          p.el.dispatchEvent(new Event('product:variant'));
        });
        const designs = slotEl.querySelector('[data-pack-designs]');
        designs.hidden = this.data.cases[kind].d < 0 || spec.logo;
        if (designs.hidden) return;
        const exist = this.designsFor(slot.model);
        if (!exist.has(slot.design)) slot.design = exist.has('Classic') ? 'Classic' : [...exist][0];
        const c = this.data.cases.slim;
        designs.querySelectorAll('.design').forEach((tile) => {
          const input = tile.querySelector('input');
          const match = slot.model && c.v.find((v) => v.o[c.m] === slot.model && v.o[c.d] === input.value);
          tile.hidden = !exist.has(input.value);
          input.disabled = tile.hidden;
          input.checked = input.value === slot.design;
          tile.toggleAttribute('data-unavailable', Boolean(match) && !match.a);
        });
        designs.querySelector('[data-design-current]').textContent = slot.design;
        const only = designs.querySelector('[data-pack-classic-only]');
        if (only) only.hidden = !(slot.model && exist.size === 1);
      });
      if (this.scrollToOpen) {
        this.scrollToOpen = false;
        this.root.querySelector(`[data-pack-slot="${this.open + 1}"]`)?.scrollIntoView({ block: 'nearest', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      /* El radio o el botón que se acaba de pulsar se esconde o se desactiva: el foco pasa a la cabecera de la
         funda que se abre (o a la de la que se acaba de completar, si ya no falta ninguna) en vez de perderse. */
      if (this.focusSlot !== undefined) {
        this.root.querySelector(`[data-pack-slot="${this.focusSlot + 1}"] [data-pack-toggle]`)?.focus({ preventScroll: true });
        this.focusSlot = undefined;
      }
    }

    /* Una funda del Dream Team: cabecera con lo elegido (abre y cierra la funda), la línea, y
       «Igual que la primera» desde la segunda. */
    renderStep(slotEl, i) {
      const slot = this.slots[i];
      const open = this.open === i;
      slotEl.toggleAttribute('data-open', open);
      slotEl.toggleAttribute('data-done', Boolean(slot.model));
      slotEl.querySelector('[data-pack-toggle]').setAttribute('aria-expanded', String(open));
      slotEl.querySelector('[data-slot-body]').hidden = !open;
      const value = slotEl.querySelector('[data-slot-value]');
      value.textContent = slot.model ? this.caseText(i) : this.t.slotEmpty;
      slotEl.querySelectorAll('[data-pack-line]').forEach((input) => { input.checked = input.value === slot.line; });
      /* «Igual que la primera»: apagado mientras la primera no tiene móvil y fuera en las fundas que ya son iguales
         que ella (Fran, 08/10/2026). Si la primera cambia después, vuelve en las que ya no lo son. */
      const same = slotEl.querySelector('[data-pack-same]');
      if (same) {
        const first = this.slots[0];
        same.hidden = Boolean(first.model) && first.model === slot.model && first.line === slot.line;
        same.disabled = !first.model;
      }
    }

    renderCords(spec) {
      const cords = this.root.querySelector('[data-pack-cords]');
      if (cords) {
        cords.hidden = spec.cords !== 'pack';
        cords.querySelector('[data-pack-custom]').hidden = !this.cordPack?.custom;
        cords.querySelector('[data-cordpack-combo]').textContent = cords.querySelector('[data-pack-cordpack]:checked')?.dataset.combo || '';
      }
      const cord = this.root.querySelector('[data-pack-cord]');
      if (cord) cord.hidden = spec.cords !== 'single';
      const set = this.root.querySelector('[data-pack-set]');
      if (set) this.renderSet(set, spec);
    }

    /* Cordones del Dream Team: una ficha por cordón con su color y las muestras de siempre debajo. */
    renderSet(set, spec) {
      set.hidden = spec.cords !== 'set';
      if (set.hidden) return;
      const ids = this.setIds();
      const swatch = (id) => set.querySelector(`[data-pack-set-input][value="${id}"]`);
      set.querySelector('[data-pack-set-same]').checked = this.same;
      set.querySelector('[data-set-tokens]').toggleAttribute('data-same', this.same);
      set.querySelectorAll('[data-set-token]').forEach((token) => {
        const n = Number(token.dataset.setToken) - 1;
        const id = ids[n];
        token.hidden = n >= ids.length;
        token.style.setProperty('--dot', id ? swatch(id)?.dataset.dot || '' : '');
        token.toggleAttribute('data-filled', Boolean(id));
        token.disabled = this.same;
        token.setAttribute('aria-pressed', String(!this.same && n === this.setActive));
        token.setAttribute('aria-label', `${this.t.cordUnit} ${n + 1}: ${id ? this.colorName(id) : this.t.chooseColor}`);
      });
      const current = this.same ? ids[0] : ids[this.setActive];
      set.querySelectorAll('[data-pack-set-input]').forEach((input) => { input.checked = Number(input.value) === current; });
      set.querySelector('[data-set-current]').textContent = this.same && ids[0] ? this.colorName(ids[0]) : '';
    }

    renderPrice() {
      const price = this.variant.p;
      const separate = this.separate();
      const save = separate - price;
      this.root.querySelector('[data-pack-price]').textContent = money(price);
      this.root.querySelector('[data-pack-add-price]').textContent = money(price);
      this.root.querySelector('[data-pack-separate]').textContent = save > 0 ? money(separate) : '';
      this.root.querySelector('[data-pack-save]').textContent = save > 0 ? this.t.save.replace('[ahorro]', money(save)) : '';
    }

    renderSummary(spec) {
      const rows = spec.slots.map((_, i) => [this.slotTitle(i).split(' · ')[0], this.caseText(i, this.t.chooseModel), !this.slots[i].model]);
      if (spec.cords === 'pack' && this.cordPack) {
        const colors = this.custom.map((id) => (id ? this.colorName(id) : '…'));
        rows.push([this.t.cordsLabel, this.cordPack.custom ? colors.join(' · ') : this.cordPack.t, this.cordPack.custom && this.custom.some((id) => !id)]);
      }
      if (spec.cords === 'single' && this.cord) rows.push([this.t.cordLabel, this.cord.t, false]);
      if (spec.cords === 'set') {
        const ids = this.setIds();
        const chosen = ids.filter(Boolean).map((id) => this.colorName(id));
        /* Los cinco de un color: «Azul (los cinco)» en vez del color cinco veces (Fran, 08/10/2026). La propiedad
           visible de la línea no cambia: es del contrato con el ERP. */
        const oneColor = this.t.setSame && chosen.length === ids.length && chosen.every((c) => c === chosen[0]);
        const value = oneColor ? this.t.setSame.replace('[color]', chosen[0]) : chosen.length ? `${chosen.join(', ')}${chosen.length < ids.length ? ', …' : ''}` : this.t.setEmpty;
        rows.push([this.t.cordsLabel, value, chosen.length < ids.length]);
      }
      if (spec.keyrings) {
        const many = spec.keyrings > 1;
        rows.push([many ? this.t.keyringMany.replace('[n]', spec.keyrings) : this.t.keyringOne, many ? this.t.keyringValueMany || this.t.keyringValue : this.t.keyringValue, false]);
      }
      if (spec.logo) rows.push([this.t.logoLabel, this.t.logoValue, false]);
      this.root.querySelector('[data-pack-summary]').replaceChildren(...rows.map(([label, value, pending]) => {
        const li = document.createElement('li');
        li.className = 'pack-summary__row';
        if (pending) li.dataset.pending = '';
        const name = document.createElement('span');
        const detail = document.createElement('span');
        name.textContent = label;
        detail.textContent = value;
        li.append(name, detail);
        return li;
      }));
    }
  }

  document.querySelectorAll('[data-pack]').forEach((root) => new Pack(root));
})();
